import styled from "styled-components"

import { DANGER, WARNING, SUCCESS, PRIMARY } from "const"

type VariantType = typeof DANGER | typeof WARNING | typeof SUCCESS | typeof PRIMARY

// eslint-disable-next-line import/prefer-default-export
export const AlertMessage = styled.div<{
    variant?: VariantType
}>`
    padding: 10px 15px;
    margin-bottom: 15px;
    border-radius: 2px;
    background: ${(props) => {
        switch (props.variant) {
            case DANGER:
                return props.theme.dangerAlertBackground
            case WARNING:
                return props.theme.warningAlertBackground
            case SUCCESS:
                return props.theme.successAlertBackground
            case PRIMARY:
            default:
                return props.theme.primaryAlertBackground
        }
    }};
    color: ${(props) => {
        switch (props.variant) {
            case DANGER:
                return props.theme.dangerAlertColor
            case WARNING:
                return props.theme.warningAlertColor
            case SUCCESS:
                return props.theme.successAlertColor
            case PRIMARY:
            default:
                return props.theme.primaryAlertColor
        }
    }};

    & a {
        color: inherit;
        border-bottom: 1px solid;

        &:hover {
            color: inherit;
            text-decoration: none;
        }
    }
`
